/**
 * Bio component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import { Link, graphql, useStaticQuery } from "gatsby"

import Img from "gatsby-image"
import React from "react"
import speakingHeroFallback from "../../content/assets/speaking-hero.png"

const About = () => {
  const data = useStaticQuery(graphql`
    query BioQuery {
      avatar: file(relativePath: { eq: "speaking-hero.png" }, sourceInstanceName: { eq: "assets" }) {
        childImageSharp {
          fixed(width: 500, height: 500) {
            ...GatsbyImageSharpFixed
          }
        }
      }
      site {
        siteMetadata {
          author
          social {
            twitter
          }
        }
      }
    }
  `)
  return (
    <>
      <div
        style={{
          display: `flex`,
        }}
      >
        {data.avatar?.childImageSharp?.fixed ? (
          <Img className="hero" fixed={data.avatar.childImageSharp.fixed} alt="Peter Elbaum speaking" />
        ) : (
          <img className="hero" src={speakingHeroFallback} alt="Peter Elbaum speaking" />
        )}
      </div>
      <div style={{ marginTop: '2rem' }}>
        <h2>What I'm Working On</h2>
        <ol>
          <li>👨🏻‍💻 I'm a software engineer pursuing <Link to="/work">self-employment</Link> through a portfolio of business activities.</li>
          <li>🌲 I acquired a small SaaS in 2025 called <a href="https://camptree.org" target="_blank">Camp Tree</a>. It helps camps start and streamline referral marketing programs.</li>
          <li>✉️ I write a weekly newsletter for Camp Tree called <a href="https://campoperations.com" target="_blank">The Referral Rundown</a>, which comes out on Tuesdays. The newsletter covers camp operations, referral marketing, and other topics related to camp management.</li>
          <li>⛺️ I help run a 5th-generation family-owned summer camp and am on the Director team there.</li>
          {/* <li>🐦 I <a href="https://twitter.com/peterelbaum" target="_blank">tweet</a> summary notes from articles and podcasts, and my thoughts about developer career growth.</li>
          <li>🎤 I speak at meetups and conferences semi-regularly, on technical and soft-skills topics.</li> */}
        </ol>

        <h2>Fun Facts</h2>
        <ol>
          {/* <li>🤓 I learn in public. This means that I try to document everything I'm learning, thinking and doing with the express purpose of providing value to others.</li> */}
          <li>🇪🇸 I studied Spanish at university and studied abroad for 5 months in Madrid. Additional fun fact: I was <a href="https://www.youtube.com/watch?v=IP2cP6uvTxA&t=1m26s" target="_blank">technically homeless</a> for my last ~6 weeks there.</li>
          <li>👫 I'm a twin! This is usually my go-to fun fact in icebreaker situations. I think being a twin is special (and fun!).</li>
        </ol>

        <h2>Curated Lists</h2>
        <p>I curate lists of resources on topics I find interesting/helpful:</p>
        <ul>
          <li><Link to="/learn-in-public">Learn in Public</Link></li>
          <li><Link to="/salary-negotiation">Salary Negotiation</Link></li>
        </ul>

        {/* <h2>Who I Follow</h2>
        <ul>
          <li><a href="https://aliabdaal.com" target="_blank">Ali Abdaal</a></li>
          <li><a href="hhttps://stephsmith.io/" target="_blank">Steph Smith</a></li>
          <li><a href="https://tim.blog/" target="_blank">Tim Ferriss</a></li>
          <li><a href="https://fs.blog/" target="_blank">Shane Parrish</a></li>
          <li><a href="https://www.indiehackers.com/" target="_blank">Courtland Allen</a></li>
          <li><a href="https://www.kalzumeus.com/" target="_blank">Patrick McKenzie</a></li>
          <li><a href="https://marketingexamples.com/" target="_blank">Harry Dry</a></li>
          <li><a href="https://joelhooks.com/" target="_blank">Joel Hooks</a></li>
          <li><a href="https://www.swyx.io/" target="_blank">Shawn Wang</a></li>
          <li><a href="https://kentcdodds.com/" target="_blank">Kent C. Dodds</a></li>
          <li><a href="https://wesbos.com/" target="_blank">Wes Bos</a></li>
          <li><a href="https://www.scotttolinski.com/" target="_blank">Scott Tolinski</a></li>
        </ul>
        
        <h2>Standing Coffee + Office Hours ☕️</h2>
        <p>If you want to talk tech, self improvement, or anything else, I'm down. If you find yourself in Raleigh and want to hang out, just let me know. I'll buy you a coffee and we can chat.</p> 
        <p>Alternatively, if you're not in Raleigh but still want to chat, please feel free to schedule a slot in my <a rel="noreferrer" href="https://calendly.com/elbaumpj/saturday-office-hours" target="_blank">office hours</a>!</p> */}
      </div>
    </>
  )
}

export default About
